<div class="loading" *ngIf="loading$|async">
	<mat-spinner></mat-spinner>
</div>
